import React from "react";
import styled from "styled-components";
import Typography from "../../../../components/common/text/Typography";
import { setColor } from "../../../../assets/styles/styles";
import Card from "./Card";
import PlaceHolderImage from "../assets/cardImages/Placeholder.png";


const ExploreSection = () => (
    <>
        <ExploreContainer>
            <Typography variant="LandingPageTitle">
                <Highlighted>explore</Highlighted>
            </Typography>

            <FeatureContainer>
                <Typography variant="LandingPageTitle" fontSize={"3rem"}>
                    make it <Highlighted>yours</Highlighted>
                </Typography>
                <CardContainer>
                    <Card src={"../videos/landingPages/explore/EasySignUp.mp4"} isVideo label="Easy Sign-Up" alt="Easy sign up" />
                    {/* <Card id="exploresignup" src={PlaceHolderImage} label="easy sign up" alt="Easy sign up" /> */}
                    <Card
                        id="exploreavatarvideo"
                        src={"../videos/landingPages/explore/PersonalizeYourAvatar.mp4"}
                        isVideo
                        label="Personalize Your Avatar"
                        alt="Personalize avatar"
                    />
                    <Card
                        id="exploretutorial"
                        src={"../videos/landingPages/explore/QuickStartGuide.mp4"}
                        isVideo
                        label="Quick start Guide"
                        alt="Quick start guide"
                    />
                    <Card
                        id="exploreroomcustomization"
                        src={"../videos/landingPages/explore/CustomizeYourRoom.mp4"}
                        isVideo
                        label="Customize Your Room"
                        alt="Customize room"
                    />
                    <Card
                        id="exploresocialize"
                        src={"../videos/landingPages/explore/MakeNewFriends.mp4"}
                        isVideo
                        label="Make New Friends"
                        alt="Make new friends"
                    />
                </CardContainer>
            </FeatureContainer>

            {/* <FeatureContainer>
                <Typography variant="LandingPageTitle">
                    <Highlighted>discover</Highlighted> something new
                </Typography>
                <CardContainer>
                    <Card id="exploreintraport" src={PlaceHolderImage} label="Browse" alt="Browse" />
                    <Card
                        id="explorecreators"
                        src={PlaceHolderImage}
                        label="Engage With Creators"
                        alt="Engage With Creators"
                    />
                    <Card
                        id="exploreigaming"
                        src={PlaceHolderImage}
                        label="Experience iGaming"
                        alt="Experience iGaming"
                    />
                    <Card id="explorearcade" src={PlaceHolderImage} label="Hit The Arcade" alt="Hit The Arcade" />
                    <Card
                        id="exploreenvironments"
                        src={PlaceHolderImage}
                        label="Worlds Await You"
                        alt="Worlds Await You"
                    />
                </CardContainer>
            </FeatureContainer> */}

            {/* <FeatureContainer>
                <Typography variant="LandingPageTitle">
                    built to <Highlighted>evolve</Highlighted>
                </Typography>
                <CardContainer>
                    <Card
                        id="exploreachievements"
                        src={PlaceHolderImage}
                        label="Earn Cool Badges"
                        alt="Earn Cool Badges"
                    />
                    <Card id="exploreavatarAI" src={PlaceHolderImage} label="Chat With AI" alt="Chat With AI" />
                    <Card
                        id="exploreliveops"
                        src={PlaceHolderImage}
                        label="Evolving Everyday"
                        alt="Evolving Everyday"
                    />
                    <Card
                        id="explorespotify"
                        src={PlaceHolderImage}
                        label="Stream With Spotify"
                        alt="Stream With Spotify"
                    />
                    <Card id="explorebroadcast" src={PlaceHolderImage} label="Tune in Live" alt="Tune in Live" />
                </CardContainer>
            </FeatureContainer> */}
        </ExploreContainer>
    </>
);

const ExploreContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 70px;
    align-self: stretch;
    padding: 150px 90px;

    @media (max-width: 768px) {
        padding: 100px 120px;
    }

    @media (max-width: 500px) {
        padding: 100px 40px;
    }
`;

const Highlighted = styled.span`
    color: ${setColor.accent4};
`;

const FeatureContainer = styled.div`
    display: flex;
    align-items: center;
    align-content: center;
    gap: 30px;
    align-self: stretch;
    flex-wrap: wrap;
`;

const CardContainer = styled.div`
    height: auto;
    width: 100%;
    display: grid;
    gap: 30px;
    grid-template-columns: repeat(3, minmax(280px, 1fr));
    justify-content: center;

    @media (max-width: 1200px) {
        gap: 60px;
        grid-template-columns: repeat(2, minmax(250px, 1fr));
    }
    @media (max-width: 768px) {
        column-gap: 60px;
        grid-template-columns: 1fr;
    }
`;

export default ExploreSection;
